import styled from "styled-components";
import fondo1 from "assets/images/fondo1.jpg";

export const MainContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-image: url(${fondo1});
  background-position: center top;
  background-size: cover;
  background-repeat: no-repeat;
`;

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgb(0 0 0 / 71%);
  overflow-x: hidden;
`;
